
import { useEffect, useState } from "react";
import {
  CenterButtonContainer,
  TextBold,
  TextMedium,
  TextRegular,
} from "../../../styles/GlobalStyledComponents";
import Button from "../../../components/Button/Button";
import { colors } from "../../../styles/Colors";
import IframeService from "../../../services/Iframe";
import TokenService from "../../../services/Token";
import { ROUTES_PATH, URL_CLIENTES } from "../../../constants";
import OnCourse from "../../../assets/images/OnCourse/OnCourse.svg";
import { useLedgerResult } from "../../../contexts/LedgerContext";
import dayjs from "dayjs";
import { pricesHelper } from "../../../utils/paymentsHelper";
import { webviewMessage } from "../../../utils/webviewHelper";
import { ImgWrapper, ModalImgDiv, ModalTextWrapper, ModalWrapper } from "../FinalModalStyledComponents";
import { ViewMode } from "../../../interfaces/Mode";
import { StorageService } from "../../../services/Storage";
import { PendingPayment } from "../../../interfaces/Payment";
import { useNavigate } from 'react-router-dom';
import { LedgerSearch } from "../../../interfaces/UserData";

const PaymentOnCourse = () => {
  const { red4, white } = colors;

  const navigate = useNavigate();

  const [paymentData, setPaymentData] = useState<LedgerSearch | null>(null);
  
  const viewMode = sessionStorage.getItem("pepper-view-mode");
  const pendingPayment: PendingPayment | null =
      JSON.parse(StorageService.getPendingPayment() ?? '{}') || null;

  const { ledgerResult } = useLedgerResult();

  const goToClientArea = () => {
    if (viewMode === ViewMode.APP || viewMode === ViewMode.IFRAME || viewMode === ViewMode.CLIENTES) {
      if (viewMode === ViewMode.APP) {
        webviewMessage({ data: "payment on course" });
      } else if (viewMode === ViewMode.CLIENTES) {
        const winRef = window.opener;
        if (winRef) {
          const targetOrigin = document.referrer;
          winRef.postMessage("payment on course", targetOrigin);
        }
      } else {
        IframeService.closeIframe("payment on course");
      }
      TokenService.clearSession();
    } else {
      TokenService.clearSession();
      window.location.href = URL_CLIENTES!;
    }
  };

  useEffect(() => {
    if (pendingPayment && ledgerResult && ledgerResult.ledgers.length > 0) {
      const ledgerInfo = ledgerResult.ledgers.find(
        (ledger) => ledger.ledger_id === pendingPayment.ledger_id
      );
      if (ledgerInfo && ledgerInfo.available_amount > 0) {
        setPaymentData(ledgerInfo);
      } else {
        setPaymentData(null);
        StorageService.removePendingPayment();
        navigate(ROUTES_PATH.ENTRY);
      }
    }
    }, [pendingPayment, ledgerResult]);

  return (
    <ModalWrapper id="on-course-page">
      <ImgWrapper>
        <ModalImgDiv src={OnCourse} alt="on course" title="on course image" width={''} height={''} />
      </ImgWrapper>
      {paymentData && (
        <>
          <ModalTextWrapper>
            <TextBold fontSize={24} align="center" id="on-course-title">
              El pago de {paymentData.available_amount && pricesHelper(paymentData.available_amount)} € está en curso
            </TextBold>
          </ModalTextWrapper>
          <ModalTextWrapper>
            <TextRegular fontSize={18} color={'gray6'} id="on-course-text">
              En breve aplicaremos el pago realizado el <TextMedium fontSize={16}>{paymentData.date && dayjs(
                paymentData.date,
                "YYYY-MM-DD"
              ).format("DD/MM/YYYY")}</TextMedium>.
            </TextRegular>
          </ModalTextWrapper>
        </>
      )}
      
      <ModalTextWrapper>
        <TextRegular fontSize={18} color={'gray6'} id="on-course-text-last">
          También puedes acceder a tu área cliente para revisar la información de tu crédito.
        </TextRegular>
      </ModalTextWrapper>
      <CenterButtonContainer>
        <Button
          color={white}
          borderColor={red4}
          backgroundColor={red4}
          minWidth="280px"
          click={() => goToClientArea()}
          id="client-area-btn"
        >
          <TextRegular fontSize={18} color={white} fontWeight={700}>
            Ir a Área Cliente
          </TextRegular>
        </Button>
      </CenterButtonContainer>
    </ModalWrapper>
  );
};

export default PaymentOnCourse;
